import { CustomCommands } from '@/shared/utils';
import { Editor } from 'grapesjs';

export default function imageSelectorTrait(editor: Editor) {

  editor.TraitManager.addType('image-selector', {
    eventCapture: ['click button'],
    // Internal properties
    imgEl: null as HTMLImageElement | null,
    btnEl: null as HTMLButtonElement | null,
    removeBtn: null as HTMLButtonElement | null,

    handleTargetChange() {
      // @ts-ignore
      const targetTraitName = this.model.get('targetTrait');
      const targetTrait = this.getComponent().getTrait(targetTraitName);
      const value = targetTrait ? targetTrait.getValue() : '';
      if (!this.imgEl) {
        // @ts-ignore
        const inputEl = this.getInputEl?.();
        this.imgEl = inputEl?.querySelector('[data-role="image-selector-preview"]') || null;
      }
      if (this.imgEl) {
        this.imgEl.src = value;
      }
    },

    handleRemoveButtonState() {
      // @ts-ignore
      const targetTraitName = this.model.get('targetTrait');
      const targetTrait = this.getComponent().getTrait(targetTraitName);

      if (!this.removeBtn) {
        // @ts-ignore
        const inputEl = this.getInputEl?.();
        this.removeBtn = inputEl?.querySelector('[data-role="image-selector-remove"]') || null;
      }

      if (this.removeBtn) {
        this.removeBtn.disabled = targetTrait.getValue() === targetTrait.getDefault();
        this.removeBtn.style.opacity = targetTrait.getValue() === targetTrait.getDefault() ? '0.5' : '1';
      }
    },

    createInput({ trait }) {
      // @ts-ignore
      const targetTraitName = trait.get('targetTrait');
      if (!targetTraitName) {
        return '<div>Error: targetTrait not specified</div>';
      }
      // @ts-ignore
      const buttonText = trait.get('buttonText') || 'Select Image';

      const wrapper = document.createElement('div');
      wrapper.className = 'd-flex align-items-center flex-column justify-content-center';

      const img = document.createElement('img');
      img.className = 'img-fluid p-2';
      img.dataset.role = 'image-selector-preview';
      wrapper.appendChild(img);


      const btnWrapper = document.createElement('div');
      btnWrapper.className = 'd-flex align-items-center my-2';

      const btn = document.createElement('button');
      btn.innerText = buttonText;
      btn.className = `btn btn-primary btn-sm`;
      btn.dataset.role = 'image-selector-select';
      btnWrapper.appendChild(btn);

      const removeBtn = document.createElement('button');
      removeBtn.className = `btn btn-danger btn-sm fa-sharp fa-trash ms-1`;
      removeBtn.dataset.role = 'image-selector-remove';
      btnWrapper.appendChild(removeBtn);

      wrapper.appendChild(btnWrapper);

      this.imgEl = img;
      this.btnEl = btn;
      this.removeBtn = removeBtn;

      // Set up listener
      const targetTraitObj = this.getComponent().getTrait(targetTraitName);
      if (targetTraitObj) {
        this.listenTo(targetTraitObj, 'change:value', this.handleTargetChange.bind(this));
      }

      // Initial update
      this.handleTargetChange();
      this.handleRemoveButtonState();
      return wrapper;
    },

    onEvent({ component, event }) {
      // @ts-ignore
      const targetTraitName = this.model.get('targetTrait');
      const targetTrait = component.getTrait(targetTraitName);

      const target = event.target as HTMLElement | null;
      const isSelectButton =
        target === this.btnEl ||
        (!!target && !!target.closest('[data-role="image-selector-select"]'));
      const isRemoveButton =
        target === this.removeBtn ||
        (!!target && !!target.closest('[data-role="image-selector-remove"]'));

      if (isSelectButton) {
        const ed = this.model.em.getEditor();
        if (!targetTrait) return;
        ed.runCommand(CustomCommands.ASSET_MANAGER_OPEN, {
          onSelect: (src: string) => {
            targetTrait.setValue(src);
            this.handleRemoveButtonState();
          }
        });
      } else if (isRemoveButton) {
        if (targetTrait) {
          targetTrait.setValue(targetTrait.getDefault() || '');
          this.handleRemoveButtonState();
        }
      }

    },

  });
} 